import { isPcOnlyPath } from "@genbaryoku/contract";
import { useLocation } from "react-router";
import { useNarrow } from "./useNarrow.js";
import { currentView } from "./view.js";

/**
 * PC 専用の機能（#185、docs/74 §1・docs/44「PC 専用の機能」）。一覧は contract の PC_ONLY_FEATURES の1か所。
 *   スマホ（スマホ版、または幅 767px 以下）のときだけ true＝「この道の入口は出さない」（灰色で出さず、メニューから消す）。
 *   メニュー・画面の中の入口は、出す前に hidden(to) を通す（ここに道を足せば、入口の側は直さずに消える）。
 *   スマホで PC版を選んだ人（viewport 1280）は PC の形＝出す
 */
export function usePcOnly(): { phone: boolean; hidden: (to: string) => boolean } {
  const narrow = useNarrow();
  const phone = currentView() === "phone" || narrow;
  return { phone, hidden: (to: string) => phone && isPcOnlyPath(to) };
}

/**
 * いまの道（パス＋問い合わせ）が PC 専用で、スマホで開いているか（#186、docs/75 a・docs/44 §11）。
 *   true のときは画面の中身を描かず、止めの画面「パソコンから操作してください」（components/StopScreen.tsx の PcOnlyStop）を出す。
 *   ルートの共通の守り（app.tsx の Authed・Registered）と、Shell の外の画面（会社の切替の /choose?new）が使う
 */
export function usePcOnlyHere(): boolean {
  const pc = usePcOnly();
  const loc = useLocation();
  return pc.hidden(loc.pathname + loc.search);
}
